import { makeStyles } from '@material-ui/core'

import React from 'react'

import { FilterChip } from 'asterX-UI/Inputs'
import { useTaskStoreManager } from 'context/HomeStore/Manager/TaskProvider/TaskProvider.manager'
import { EVENT_TYPE, EVENT_TYPE_FILTER } from 'constants/events'

const useStyle = makeStyles(theme => ({
  rootDiv: {
    display: 'flex',
    overflowX: 'auto',
    gap: 6,
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  }
}))

const Filter = () => {
  const { taskStore, taskStoreFunc } = useTaskStoreManager()
  const classes = useStyle()
  const maxWidth = window.innerWidth - 16

  return (
    <div className={classes.rootDiv} style={{ maxWidth }}>
      <FilterChip
        type={'INPUT'}
        label={'РЛ'}
        value={taskStore.filter.globalId}
        name={'globalId'}
        textType={'number'}
        onChange={taskStoreFunc.onChangeFilter}
      />

      <FilterChip
        type="MULTI_SELECT"
        label="Тип задачи"
        value={taskStore.filter.types}
        name="types"
        valueKey={'code'}
        labelKey={'name'}
        options={EVENT_TYPE_FILTER}
        onChange={taskStoreFunc.onChangeFilter}
      />

      <FilterChip
        type={'INPUT'}
        label={'Телефон'}
        value={taskStore.filter.contactPhone1}
        name={'contactPhone1'}
        onChange={taskStoreFunc.onChangeFilter}
      />

      <FilterChip
        type={'INPUT'}
        label={'Имя'}
        value={taskStore.filter.contactFullname}
        name={'contactFullname'}
        onChange={taskStoreFunc.onChangeFilter}
      />
    </div>
  )
}

export default Filter
